import { apiSlice } from "../api/apiSlice";

export const taskApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getTasks: builder.query({
            query: () => ({
                url: "/tasks"
            })
        }),
        getTask: builder.query({
            query: (id) => ({
                url: `/tasks/${id}`
            })
        }),
        addTask: builder.mutation({
            query: (data) => ({
                url: "/tasks",
                method: "POST",
                body: data,
            }),
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                // pessimistically cash update

                try {
                    const newTask = await queryFulfilled;
                
                    dispatch(apiSlice.util.updateQueryData("getTasks", undefined, (draftTasks) => {
                        draftTasks.push(newTask.data)
                    }));
                } catch (error) {
                    // patchResult.undo()
                }
            }
        }),
        updateTask: builder.mutation({
            query: (data) => ({
                url: `/tasks/${data.id}`,
                method: "PATCH",
                body: data,
            }),
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                // optimistic cash update
                const patchResult = dispatch(apiSlice.util.updateQueryData("getTasks", undefined, (draftTask) => {
                    const draftTaskResult = draftTask.find(task => task.id == arg.id);
                    draftTaskResult.taskName = arg.taskName;
                    draftTaskResult.teamMember = { ...arg.teamMember };
                    draftTaskResult.project = { ...arg.project };
                    draftTaskResult.deadline = arg.deadline;
                    draftTaskResult.status = arg.status ? arg.status : ""

                }));

                try {
                    await queryFulfilled;
                } catch (error) {
                    patchResult.undo()
                }
            }
        }),
        deleteTask: builder.mutation({
            query: (id) => ({
                url: `/tasks/${id}`,
                method: "DELETE",
            }),
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                // optimistic cash update
                const patchResult = dispatch(apiSlice.util.updateQueryData("getTasks", undefined, (draftTasks) => {
                    const index = draftTasks.findIndex(task => task.id == arg);
                    draftTasks.splice(index, 1)
                }));

                try {
                    await queryFulfilled;
                } catch (error) {
                    patchResult.undo()
                }
            }
        }),
    })
})

export const { useGetTasksQuery, useGetTaskQuery, useAddTaskMutation, useUpdateTaskMutation, useDeleteTaskMutation } = taskApi